import BaseComponent from "../baseComponent.js";
import styles from "./terms-and-conditions.scss";

export default class TermsAndConditions extends BaseComponent {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    var target = $(".privacy-content");
    target.scroll(function () {
      var scrollHeight = target.get(0).scrollHeight;
      var sHeight = target.scrollTop() + target.height();
      if (sHeight >= scrollHeight) {
        $(".agree-btn").removeClass("disabled").addClass("agree-btn--activated");
      }
    });

    this.$modal = $("#privacy-and-terms");
    this.$modal.modal({
      dismissible: false
    });
  }

  show() {
    this.$modal.modal("open");
  }

  hide() {
    this.$modal.modal("close");
  }

  render() {
    return (
      <div id="privacy-and-terms" className="modal" style={{maxHeight: "100%"}}>
        <div className="modal-content">
          <div className="header">
            <div className="title">SMASH TERMS AND CONDITIONS OF USE</div>
            <div className="agree">By choosing "I agree" below you agree to Smash's Terms of Service.
            </div>
          </div>
          <div className="privacy-content">
            <div className="last-update">LAST UPDATED: August 15, 2016</div>
            <h2>PLEASE READ THESE TERMS AND CONDITIONS, WHICH GOVERN YOUR USE OF THIS AND OTHER SMASH
              SERVICES*</h2>
            <p>
              Smash.bi Inc., an Ontario corporation, and its affiliates and subsidiaries
              (collectively, <b>"Smash"</b>, <b>"our"</b>, <b>"us"</b> or <b>"we"</b>) makes
              information, products, and services
              available on our website(s), through your or other's websites, or through other
              operating platforms or systems (each, a <b>"Platform"</b>), subject to the following
              terms and
              conditions of use (<b>"Terms and Conditions"</b>). By using any Platform or service
              controlled
              or provided by Smash (each, a <b>"Service"</b> or collectively, <b>"Services"</b>),
              you agree to be
              bound by all of the terms in these Terms and Conditions. You may wish to print and keep
              a copy of these Terms and Conditions. Smash may change the terms in these Terms and
              Conditions at any time and such changes will be binding on you if you continue to use a
              Service after we have notified you (by email, notification on the site, on a Service, or
              by any other means by which you obtain such notice) that we have changed the terms.
              Therefore, you should review these Terms and Conditions each time we notify you that we
              have changed the terms. Smash may discontinue or change any Service, or its availability
              to you, at any time. For the purposes of these Terms and Conditions, <b>"Data"</b> means
              organized information, whether numeric, alphanumeric, facts or statistics, and
              augmented, as applicable, by descriptive information such as names, dates, labels,
              descriptions and other metadata, and includes, without limitation, text, studies,
              analyses, graphics, images, videos, documents, tools, calculators and other similar
              items.
            </p>
            <h2>ACCEPTANCE OF TERMS</h2>
            <p>
              By using the Service, you agree to be bound by these Terms and Conditions. If you do not
              agree to these Terms and Conditions, any use of the Service is unauthorized and
              prohibited. Smash provides the information, products and services on the Platform to
              you, conditioned upon your acceptance, without modification, of the Terms and Conditions
              contained herein. Your use of the Platform constitutes your agreement with such Terms
              and Conditions.
            </p>
            <p>
              By using a Service, you represent, warrant and covenant that you (if you are an
              individual) are at least 18 years of age, can form legally binding contracts, and (if
              applicable) are the authorized representative of the entity that is agreeing to these
              Terms and Conditions. The Services are not designed for use by individuals under 18
              years of age, and use by such individuals is not permitted. These Terms and Conditions
              are personal to you, and you may not delegate or assign your obligations under them to
              anyone.
            </p>
            <h2>COPYRIGHT AND LIMITATIONS ON USE</h2>
            <p>
              The content available through each Service is the property of Smash or its third party
              content providers (<b>"Data Providers"</b>) and is protected by copyright and other
              intellectual property laws. Such content may include Data displayed on or through the
              Service. Content received through a Service may be displayed, reformatted, and printed
              for your personal, non-commercial use only. You agree not to reproduce, retransmit,
              distribute, disseminate, sell, publish, broadcast or circulate the content received
              through a Service to anyone, including but not limited to others in the same company or
              organization, without the express prior written consent of Smash, except through use of
              the Service's sharing features, to the extent such features are made available on a
              Service. You may not post any content from any Service to newsgroups, mail lists or
              electronic bulletin boards without the prior written consent of Smash. You may not use
              any of the Data found on or through a Service in connection with the issuance, trading,
              marketing or promotion of investment products (e.g., derivatives, structured products,
              investment funds, investment portfolios, etc., where the price, return and/or
              performance of the investment product is based on or related to such Data), nor may you
              use such Data as the basis of a financial instrument, without a separate written
              agreement with Smash and any of our applicable Data Providers. Except as may be
              permitted above, you agree not to copy, modify, reformat, download, store, reproduce,
              reprocess, transmit or redistribute any Data or information found on or through any
              Service or use any such Data or information in a commercial enterprise without obtaining
              our prior written consent.
            </p>
            <p>
              Some Data Providers will have additional terms and conditions and by accessing their
              content, you agree to be bound by these additional terms and conditions. If you do not
              agree to these additional terms and conditions, any use of such Data Providers' content
              is unauthorized and prohibited. Smash provides such content to you, conditioned upon
              your acceptance, without modification, of such additional terms and conditions as
              applicable. Your use of the Platform constitutes your agreement with all such additional
              terms and conditions. Such Data Providers' terms and conditions are in addition to
              Smash's Terms and Conditions.
            </p>

            <h1>Research Use Only</h1>
            <p>
              The content on each Service is provided for informational and research purposes only, as
              of the date provided, and is subject to change without notice. Service content is not
              intended to be an offer, or the solicitation of any offer, to buy or sell securities.
            </p>

            <h1>User-Provided Content, Suggestions, and Feedback</h1>
            <p>
              Users may provide Smash with content, ideas, suggestions, feedback, documents or
              proposals (<b>"User-Provided Content"</b>), including but not limited to Data, bug
              reports,
              content suggestions, Service design suggestions, and requested features.
            </p>
            <p className="no-margin">
              Users will be asked to designate their User-Provided Content as one of:
            </p>
            <ol>
              <li>
                private content which will not be shared by Smash with any third-party (<b>"Private
                Content"</b>);
              </li>
              <li>
                shareable content which may be shared by Smash to its Users, free of charge
                (<b>"Shareable Content"</b>); or
              </li>
              <li>
                resale content which may be shared by Smash to its Users for a fee (<b>"Resale
                Content"</b>).
              </li>
            </ol>

            <p>
              Upon acceptance of these Terms and Conditions, you hereby agree to provide the
              User-Provided Content to Smash and grant to Smash the non-exclusive right to store, and
              in respect of Shareable Content and Resale Content, market and distribute the
              User-Provided Content to other users of the Service (<b>"Other Users"</b>) via any
              Platform.
            </p>

            <p className="no-margin">
              By sending us any such User-Provided Content, you represent, warrant, and agree that:
            </p>

            <ol>
              <li>
                your User-Provided Content does not contain confidential or proprietary information,
                or copyrighted material of third parties;
              </li>
              <li>
                we are under no obligation of confidentiality not otherwise outlined in these Terms
                and Conditions;
              </li>
              <li>
                we may already have something similar under consideration or development;
              </li>
              <li>
                you comply with all data security and privacy laws that apply in the countries where
                Smash operates and in the country where you live and operate;
              </li>
              <li>
                you shall be solely responsible for your own User-Provided Content and the
                consequences of submitting and publishing your User-Provided Content on the
                Platform;
              </li>
              <li>
                you own or have the necessary licenses, rights, consents, and permissions to publish
                the User-Provided Content you submit, and in respect of Shareable Content and Resale
                Content, you license to Smash all patent, trademark, trade secret, copyright or
                other proprietary rights in and to such User-Provided Content for publication on the
                Platform pursuant to these Terms and Conditions;
              </li>
              <li>
                in respect of Shareable Content and Resale Content, you grant Smash a non-exclusive,
                royalty-free, perpetual, irrevocable, and fully sub-licensable right to use,
                reproduce, store, display, modify, adapt, publish, translate, create derivative
                works from, distribute, market and share such content throughout the world in any
                media;
              </li>
              <li>
                in respect of Shareable Content and Resale Content, you grant to Other Users a
                non-exclusive license to access your User-Provided Content through the Services, and
                to use, reproduce, distribute and display such User-Provided Content through the
                functionality of the Services and under these Terms and Conditions;
              </li>
              <li>
                in respect of Shareable Content and Resale Content, you grant Smash the right, but
                not the obligation, to publish visualizations and/or small samples of User-Provided
                Content for marketing purposes, subject to your prior written approval of any such
                proposed marketing program; and
              </li>
              <li>
                in respect of Shareable Content and Resale Content, you grant Smash the right, but
                not the obligation, to conduct an SEO marketing program involving the publishing of
                small samples of User-Provided Content on webpages designed to be highly
                discoverable via search engines.
              </li>
            </ol>

            <p>
              The identity of the users that provide User-Provided Content will be kept confidential,
              as will any information covered by the Confidentiality section within these Terms and
              Conditions and the Smash Privacy Policy (available at <a
              href="http://www.smash.bi/privacy" target="_blank">http://www.smash.bi/privacy</a>). You
              represent and warrant that you own or otherwise control all of the rights to the
              User-Provided Content that you provide; that the User-Provided Content is accurate; that
              use of the User-Provided Content you supply does not violate this policy and will not
              cause injury to any person or entity; and that you will indemnify Smash for all claims
              resulting from User-Provided Content you supply, knowing it to be false, inaccurate, or
              intentionally harmful. Smash has the right but not the obligation to store User-Provided
              Content.
            </p>

            <h1>Revocation</h1>
            <p>
              You may revoke access to User-Provided Content to any or all Other Users upon delivery
              of notice to Smash, which notice shall include the Other Users which cannot use
              User-Provider Content and the reasons for such revocation. Smash shall use reasonable
              efforts to suspend access of such identified Other Users to such User-Provided Content
              within five business days of such notice.
            </p>

            <h1>Data Privacy and Security</h1>
            <p>
              Smash acts strictly as a data bank, facilitating the exchange of User-Provided Content
              between you and Other Users. Smash is a flow through service provider and accepts no
              responsibility for the content of User-Provided Content provided by you or for the use
              of such User-Provided Content by Other Users. Notwithstanding anything contained herein,
              you agree that Smash is not responsible for any breach of such terms and conditions by
              Other Users and agrees not to make any claim against Smash in connection with any breach
              of such terms and conditions by Other Users.

            </p>
            <p>
              You will strictly comply and warrant compliance with all data security and privacy laws
              and regulations in the countries where Smash operates, where you live and/or operate,
              and/or where User-Provided Content is transferred. Smash disclaims responsibility for
              your compliance with data security and privacy laws that do or may apply to you from
              these Terms and Conditions and services provided under these Terms and Conditions. This
              disclaimer includes but is not limited to data subject consents, whether opt out or opt
              in depending on the jurisdiction. You agree to investigate and comply with local
              requirements for data protection and to instruct Smash on such conditions and
              requirements. Smash may refuse to transfer any User-Provided Content without your full
              compliance with this requirement. Smash itself will comply with all local jurisdiction
              requirements applicable to a processor where Smash operates or where Smash transfers
              User-Provided Content at your request.
            </p>

            <p className="no-margin">You agree with us that:</p>
            <ol>
              <li>
                You will process and transfer personal data received in accordance with prevailing
                applicable legislation relating to data protection and with any applicable guidance
                or recommendations issued by a relevant data protection authority;
              </li>
              <li>
                You will put in place appropriate technical and organizational measures to protect
                the personal data;
              </li>
              <li>
                You shall neither instruct the other to do nor omit to do things in relation to
                User-Provided Content provided by it through the Platform or the Services, which are
                in violation of any applicable laws and regulations;
              </li>
              <li>
                Smash reserves the right to remove any content it deems inappropriate or in
                violation of the terms of these Terms and Conditions; and
              </li>
              <li>
                Smash reserves the right to refuse services to anyone, including any Other Users,
                for any reason and at any time.
              </li>
            </ol>

            <h1>Copyright Policy</h1>
            <p>
              Smash operates a clear copyright policy in relation to any content (including
              User-Provided Content) alleged to infringe the copyright of a third party. Details of
              that policy can be found here <a href=" http://www.smash.bi/copyright-takedown"
                                               target="_blank">http://www.smash.bi/copyright-takedown.</a>
              As part of Smash's
              copyright policy, Smash will terminate user access to the Platform and/or the Services
              if a user has been determined to be a repeat infringer. A repeat infringer is a user who
              has been notified of infringing activity more than twice.
            </p>

            <h1>Confidentiality</h1>
            <p>
              The terms of the Premium Services Subscription Agreement entered into by you and Smash
              are confidential, and will not be disclosed to any parties not included in the terms of
              said agreement. Unless otherwise permitted elsewhere in the Copyright and Limitations on
              Use section of these Terms and Conditions, the Service itself and any content provided
              is confidential, and you agree not to reproduce, retransmit, distribute, disseminate,
              sell, publish, broadcast, or otherwise share information about or derived from your use
              and access to the Service. Smash will treat any proprietary Data you use or provide in
              connection with the Service as confidential, including any questions you ask in
              connection with help conducting research via the Service.
            </p>

            <h1>No Reverse Engineering</h1>
            <p>
              The systems used by Smash to provide a Service are confidential, including but not
              limited to the computer hardware and software the Service runs on. Any system for a
              Service provided by Smash shall not be modified, disassembled, decompiled, or reverse
              engineered, nor should you cause a third party to modify, disassemble, decompile, or
              reverse engineer the same for any purpose.
            </p>

            <h2>ADDITIONAL RESTRICTIONS</h2>
            <p className="no-margin">When using the Services and any other Smash products, you agree not
              to:</p>
            <ol>
              <li>
                post content or items in an inappropriate category or areas on the Platform or
                through the Services;

              </li>
              <li>
                violate any laws, third party rights or Smash policies;
              </li>
              <li>
                falsely represent any person or entity, including but not limited to Smash employees
                and representatives, or to falsely state or otherwise misrepresent an affiliation
                with a person or entity;

              </li>
              <li>
                fail to deliver payment for items purchased or services subscribed by you;
              </li>
              <li>
                post or make available false, inaccurate, misleading, defamatory, or libelous
                content through the Platform;
              </li>
              <li>
                act in a way to any way deliberately degrades or disables Smash services and the
                Platform or the user experience of Other Users;

              </li>
              <li>
                transfer ownership of your account to another party without our consent;

              </li>
              <li>
                distribute or post spam, unsolicited, or bulk electronic communications, chain
                letters, or pyramid schemes;

              </li>
              <li>
                distribute viruses or any other technologies that may harm Smash, or the interests
                or property of Other Users;

              </li>
              <li>
                copy, modify or distribute rights or content from the Platform, service or tools,
                except as permitted hereunder or by agreement with Smash;
              </li>
              <li>
                harvest or otherwise collect information about Other Users or the data provided by
                such Other Users, including e-mail addresses, without their consent;

              </li>
              <li>
                use Smash or the Platform to contact Other Users or other persons as identified in
                the data provided by such Other Users to make offers to buy or sell items or provide
                services to such persons outside of Smash; and

              </li>
              <li>
                use any robot, spider, scraper or other automated means to access the sites for any
                purpose without Smash's express written permission.

              </li>
            </ol>

            <p>
              Users violating Smash Agreements or deemed to have violated terms of conduct or spirit
              of our policies may have rights to use Smash services and sites suspended or terminated
              without notice. Suspension or termination may result in the loss of data and account
              information stored by, or provided to Smash.
            </p>

            <h2>REGISTRATION</h2>
            <p className="no-margin">You may be required to register with Smash in order to access
              certain areas of the Platform. In the course of registration, you must:
            </p>
            <ol>
              <li>
                provide true, accurate, current and complete information on the registration form;
                and

              </li>
              <li>
                maintain and promptly update such registration information as necessary.

              </li>
            </ol>
            <p>
              If, after investigation, we have reasonable grounds to suspect that any user's
              information is untrue, inaccurate, not current or incomplete, we may suspend or
              terminate that user's account and prohibit any and all current or future use of the
              Platform (or any portion thereof) by that user. You may not use a user name (or e-mail
              address) that is already being used by someone else; that may be construed as
              impersonating another person; that belongs to another person; that violates the
              intellectual property or other rights of any person; that is offensive; or that Smash
              rejects for any other reason in its sole discretion. You are responsible for protecting
              your user name and password from unauthorized use, and you are responsible for all
              activity that occurs on your account. You agree to notify us immediately if you believe
              that your user name and password have been or may have been used without your permission
              so that appropriate action can be taken. We are not responsible for losses or damage
              caused by your failure to safeguard your user name and password.

            </p>

            <h2>SUBSCRIBER FEES</h2>
            <p>
              Smash may charge subscriber fees for access to Service features (<b>"Premium Services"</b>).
              Your access to Premium Services will be subject to your registration as a registered
              user and agreement to pay such fees. Your Service subscription will continue based on
              your Premium Services Subscription Agreement until you cancel your subscription or we
              terminate it. You must provide us with a current, valid, accepted method of payment (as
              such may be updated from time to time, <b>"Payment Method"</b>) to use the Premium Services.
              You must cancel your subscription before it renews in order to avoid billing of the next
              subscription period to your Payment Method.
            </p>

            <h1>Billing</h1>
            <p>
              By starting your Service subscription, you authorize us to charge you a subscription fee
              in accordance with your Premium Services Subscription Agreement to your Payment Method.
              We reserve the right to change our subscription fees from time to time, but we will not
              increase the subscription fees we charge to you during the current period of your
              subscription and will not increase the subscription fees we charge to you for renewal
              period without providing you at least (30) thirty days' notice of such change prior to
              your renewal date. We will begin billing you for your subscription at the beginning of
              the paying portion of your subscription and each subscription period thereafter unless
              and until you give us written notice prior to expiration of the then-current
              subscription term that you do not wish to renew. Written notice is to be provided
              according to the terms in your Premium Services Subscription Agreement. We will
              automatically bill your Payment Method in accordance to the term corresponding to the
              commencement of your Service subscription. Subscription fee installments are fully
              earned each month upon payment, for monthly subscriptions. We reserve the right to
              change the timing of our billing.
            </p>

            <h2>No Refunds</h2>
            <p>
              PAYMENTS ARE NON-REFUNDABLE. Following any cancellation by you during a subscription
              period, however, you will continue to have access to the applicable Service through the
              end of such subscription period. If you cancel during an annual subscription period, you
              will remain responsible for paying any unpaid portion of the annual subscription fee. At
              any time, and for any reason, we may provide a refund, discount, or other consideration
              to some or all of our subscribers (<b>"Credits"</b>). The amount and form of such Credits,
              and
              the decision to provide them, are at the sole and absolute discretion of Smash. The
              provision of Credits in one instance does not entitle you to Credits in the future or
              for similar instances, nor does it obligate Smash to provide Credits in the future,
              under any circumstance.
            </p>

            <h2>DISCLAIMER OF LIABILITY AND WARRANTIES</h2>
            <p>
              YOUR USE OF THE SERVICE IS AT YOUR OWN RISK. ALL SERVICE CONTENT, INFORMATION, OR
              PRODUCTS MADE AVAILABLE ARE PROVIDED ON AN "AS IS" AND "AS AVAILABLE" BASIS WITHOUT
              WARRANTY OF ANY KIND, INCLUDING BUT NOT LIMITED TO THE MERCHANTABILITY, FITNESS FOR ANY
              PARTICULAR PURPOSE OR NON-INFRINGEMENT OF ANY SERVICE CONTENT, OR THAT A SERVICE WILL BE
              AVAILABLE, FREE FROM ERRORS, VIRUSES OR OTHER HARMFUL COMPONENTS. SMASH AND ITS
              AFFILIATES, AGENTS AND LICENSORS CANNOT AND DO NOT WARRANT THE ACCURACY, COMPLETENESS OR
              TIMELINESS OF THE CONTENT AVAILABLE THROUGH ANY SERVICE. IN NO EVENT SHALL SMASH AND/OR
              ITS SUPPLIERS/LICENSORS AND ITS AND THEIR OFFICERS, DIRECTORS, EMPLOYEES OR AGENTS BE
              LIABLE FOR ANY SPECIAL, INCIDENTAL OR CONSEQUENTIAL OR PUNITIVE DAMAGES ARISING OUT OF
              OR IN CONNECTION WITH YOUR USE OF THE SERVICE OR THIS AGREEMENT INCLUDING, WITHOUT
              LIMITATION, ANY DAMAGES RESULTING FROM LOSS OF USE, DATA, PROFITS OR OTHER INTANGIBLES,
              LOSS OF SECURITY OF INFORMATION YOU HAVE PROVIDED IN CONNECTION WITH YOUR USE OF THE
              SERVICE (HOWEVER ARISING, INCLUDING CONTRACT, EQUITY, NEGLIGENCE OR OTHER TORTIOUS
              ACTION) EVEN IF ADVISED IN ADVANCE OF SUCH DAMAGES OR LOSSES. TO THE EXTENT SUCH
              DISCLAIMER OF DAMAGES IS NOT EFFECTIVE UNDER APPLICABLE LAW, THE ENTIRE AGGREGATE
              LIABILITY TO YOU OF SMASH, ITS AFFILIATES, AGENTS OR LICENSORS WILL BE LIMITED TO THE
              FEES, IF ANY, YOU PAID TO SMASH FOR ACCESS TO THE SERVICE THAT GAVE RISE TO SUCH
              LIABILITY.
            </p>

            <h2>THIRD PARTIES</h2>
            <p>
              The Website displays links to other websites and content, information and data obtained
              from other websites. You agree that we are not responsible or liable for any actions or
              inactions of other websites.
            </p>
            <p>
              You understand that we may use third-party vendors to provide necessary hardware,
              software, networking, storage, and related technology to run the Website. You agree and
              acknowledge that we are not responsible in any manner whatsoever for any actions or
              inactions of such third-parties.
            </p>
            <h1>Third Party Content and Services</h1>
            <p>
              Smash is a distributor (and not a publisher) of content supplied by Data Providers.
              Services may include facts, views, opinions and recommendations of individuals and
              organizations deemed of interest. Smash and its Data Providers do not guarantee the
              accuracy, completeness or timeliness of, or otherwise endorse, these facts, views,
              opinions or recommendations, give tax or investment advice, or advocate the purchase or
              sale of any security or investment. Any opinions, advice, statements, services, offers,
              or other information or content expressed or made available by third parties, including
              but not limited to any Other User or any Data Provider, are those of the respective
              author(s) or distributor(s) and not of Smash. Smash neither endorses nor is responsible
              for the accuracy or reliability of any opinion, advice or statement made on a Service by
              anyone other than authorized Smash employee spokespersons while acting in their official
              capacities. Under no circumstances will Smash or any of its Data Providers be liable for
              any loss or damage relating to your use of information obtained through a Service. It is
              your responsibility to evaluate the accuracy, completeness or usefulness of any
              information, opinion, advice or other content available through a Service. Please seek
              the advice of professionals regarding the evaluation of any specific information,
              opinion, advice or other content obtained on a Service.
              Our use of third party sources for certain Service content, and the inherent hazards of
              electronic distribution, may result in delays, omissions or inaccuracies in such content
              as presented on a Service. Some of the data on Services may be delayed as specified by
              Data Providers. Smash does not verify any data and disclaims any obligation to do so.
              Smash, its Data Providers and each of their affiliates and business partners (A)
              expressly disclaim the accuracy, adequacy, usefulness, or completeness of any data and
              (B) shall not be liable for any errors, omissions or other defects in, delays or
              interruptions in such data, or for any actions taken in reliance thereon. As used here,
              "business partners" does not refer to an agency, partnership, or joint venture
              relationship between Smash and any such parties.
            </p>

            <h2>TERMINATION</h2>
            <p>
              Either Smash or you may terminate your access to Services or any portion or feature
              thereof at any time. Without limiting the foregoing, Smash may, in its sole discretion,
              at any time for any reason or no reason, terminate your access to this Service, or any
              portion or feature thereof, including if Smash believes that you have violated or acted
              inconsistently with the letter or spirit of these Terms and Conditions, or the Premium
              Services Subscription Agreement or if it is required by applicable law, regulation,
              court or governing agency order. Smash shall not be liable to you or any third party for
              any termination of your access to the Services, the Platform or any account granted by
              Smash to you.
            </p>

            <h2>INCONSISTENCIES</h2>
            <p>
              In the event that you wish to market or sell Resale Content using the Platform or our
              Services, you will be required to agree to our Data Reseller Agreement, or such other
              Smash agreement as may be in effect from time to time. To the extent of any
              inconsistency between these Terms and Conditions and such other agreement, the
              provisions of such other agreement shall prevail and take priority.
            </p>

            <h2>GENERAL CONTRACT PROVISIONS
            </h2>
            <p>
              In the event that any of the Terms and Conditions herein contained shall be held
              unenforceable or declared invalid for any reason whatsoever, such enforceability or
              invalidity shall not affect the enforceability or validity of the remaining Terms and
              Conditions of this Agreement and such unenforceable or invalid portion shall be
              severable from the remainder of the Agreement.
            </p>
            <p>
              These Terms and Conditions, your obligations, and all actions contemplated by these
              Terms and Conditions shall be governed by and construed in accordance with the laws of
              Ontario and any court of competent jurisdiction in Ontario shall have jurisdiction to
              adjudicate any matter arising out of this Agreement.
            </p>
          </div>
          <div className="footer">
            <a className="waves-effect btn-flat cancel-btn" onClick={this.hide}>Cancel</a>
            <a className="waves-effect waves-light btn-flat agree-btn disabled" onClick={this.props.onAgree}>I agree</a>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/auth/termsAndConditions.jsx